/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetOrganizationCombos200ResponseItemsInner } from './GetOrganizationCombos200ResponseItemsInner';
import {
    GetOrganizationCombos200ResponseItemsInnerFromJSON,
    GetOrganizationCombos200ResponseItemsInnerFromJSONTyped,
    GetOrganizationCombos200ResponseItemsInnerToJSON,
    GetOrganizationCombos200ResponseItemsInnerToJSONTyped,
} from './GetOrganizationCombos200ResponseItemsInner';

/**
 * 
 * @export
 * @interface GetOrganizationCombos200Response
 */
export interface GetOrganizationCombos200Response {
    /**
     * 
     * @type {Array<GetOrganizationCombos200ResponseItemsInner>}
     * @memberof GetOrganizationCombos200Response
     */
    items: Array<GetOrganizationCombos200ResponseItemsInner>;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationCombos200Response
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationCombos200Response
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationCombos200Response
     */
    itemsPerPage: number;
}

/**
 * Check if a given object implements the GetOrganizationCombos200Response interface.
 */
export function instanceOfGetOrganizationCombos200Response(value: object): value is GetOrganizationCombos200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('itemsPerPage' in value) || value['itemsPerPage'] === undefined) return false;
    return true;
}

export function GetOrganizationCombos200ResponseFromJSON(json: any): GetOrganizationCombos200Response {
    return GetOrganizationCombos200ResponseFromJSONTyped(json, false);
}

export function GetOrganizationCombos200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrganizationCombos200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetOrganizationCombos200ResponseItemsInnerFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'itemsPerPage': json['itemsPerPage'],
    };
}

export function GetOrganizationCombos200ResponseToJSON(json: any): GetOrganizationCombos200Response {
    return GetOrganizationCombos200ResponseToJSONTyped(json, false);
}

export function GetOrganizationCombos200ResponseToJSONTyped(value?: GetOrganizationCombos200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(GetOrganizationCombos200ResponseItemsInnerToJSON)),
        'total': value['total'],
        'page': value['page'],
        'itemsPerPage': value['itemsPerPage'],
    };
}

